import { createContext, useContext, type ReactNode } from 'react';
import type { MaintenanceBannerProp } from '@/utils/get-global-settings-props';

const MaintenanceBannerContext = createContext<MaintenanceBannerProp>(null);

export const MaintenanceBannerProvider = ({
  value,
  children,
}: {
  value: MaintenanceBannerProp;
  children: ReactNode;
}) => <MaintenanceBannerContext.Provider value={value}>{children}</MaintenanceBannerContext.Provider>;

export const useMaintenanceBanner = (): MaintenanceBannerProp => useContext(MaintenanceBannerContext);

export { MaintenanceBannerContext };
